import React from 'react'
import { Form } from '../../ui/Form/Form'
import { Slider } from '../../ui/Slider/Slider'

export const ContainerLog = () => {
  return (
    <div className='ContainerLog'>
        <Form/>
        <Slider/>
    </div>
  )
}
